import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CourseDetail from "@/pages/CourseDetail";
import Admin from "@/pages/Admin";
import Disclaimer from "@/pages/Disclaimer";
import PurchaseSuccess from "@/pages/PurchaseSuccess";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return FIRST (URL fragment), before any route renders.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/courses/:slug" element={<CourseDetail />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/purchase-success" element={<PurchaseSuccess />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-[#0B0C10] px-6 text-center" data-testid="not-found-page">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]">404</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white font-light mt-5">Page not found</h1>
        <p className="text-[#9CA3AF] mt-4">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="inline-block mt-8 bg-[#D4AF37] text-[#0B0C10] font-medium hover:bg-[#F1D570] transition-colors rounded-sm px-8 py-3" data-testid="not-found-home">
          Back to home
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#12141A", border: "1px solid #1F222E", color: "#F8F9FA" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
